PF.Entity.EventsCoreTrait = class EventsCoreTrait extends PF.Trait
	{
	initTrait()
		{
		Object.defineProperty(this, 'entityEvents', {
			enumerable: false,
			configurable: true,
			value: [],
		});
		Object.defineProperty(this, 'entityDelegatedEvents', {
			enumerable: false,
			configurable: true,
			value: [],
		});
		Object.defineProperty(this, 'entityProps', {
			enumerable: false,
			configurable: true,
			value: {},
		});
		}

	setter(key, value)
		{
		let oldValue = this.entityProps[key];
		if (!PF.H.isSame(oldValue, value))
			{
			this.trigger('beforeChange:' + key, oldValue, value, key);
			this.entityProps[key] = value;
			this.trigger('change:' + key, oldValue, value, key);
			}
		}

	defineProperty(key, object = this)
		{
		if (key in object.entityProps)
			{
			return;
			}
		object.entityProps[key] = object[key];

		Object.defineProperty(object, key, {
			configurable: true,
			enumerable: true,
			get()
				{
				return object.entityProps[key];
				},
			set(value)
				{
				object.setter(key, value);
				}
		});
		}


	on(name, callback, callOnInit = false)
		{
		// console.log('on', name);

		if (name instanceof Array)
			{
			for (let i = 0; i < name.length; i++)
				{
				this.on(name[i], callback, false);
				}
			if (callOnInit === true)
				{
				callback();
				}
			return;
			}

		let path = name.split('.');
		if (path.length > 1)
			{
			this.delegateEvent(name, callback);
			}
		else
			{
			this.addEvent(name, callback);
			let propModEventReg = /^change:|^beforeChange:/;
			if (propModEventReg.test(name))
				{
				this.defineProperty(name.replace(propModEventReg, ''));
				}
			}
		if (callOnInit === true)
			{
			callback();
			}
		}

	addEvent(name, callback)
		{
		this.entityEvents.push({
			name: name,
			callback: callback,
			clearName: name.split('@')[0],
			ns: name.split('@')[1],
		});
		}

	delegateEvent(name, callback)
		{
		let path = name.split('.');
		if (path.length > 1)
			{
			let targetName = path.shift();
			let delegatedName = path.join('.');

			if (targetName === '*' && this instanceof PF.Entity.Array)
				{
				for (let i = 0; i < this.length; i++)
					{
					this[i].on(delegatedName, callback);
					}
				let addCallback = (addedItem) => {
					addedItem.on(delegatedName, callback);
				};
				let removeCallback = (removedItem) => {
					removedItem.off(delegatedName, callback);
				};
				this.on('addOne', addCallback);
				this.on('removeOne', removeCallback);
				this.entityDelegatedEvents.push({
					type: 'array',
					name: name,
					delegatedName: delegatedName,
					callback: callback,
					path: path.join('.'),
					addCallback: addCallback,
					removeCallback: removeCallback,
				});
				}
			else
				{
				// let beforeChangeCallback = (oldTarget) => {
				// 	if (oldTarget instanceof Object)
				// 		{
				// 		oldTarget.off(delegatedName, callback);
				// 		}
				// };
				let changeCallback = (oldValue, value, key) => {
					if (oldValue instanceof Object)
						{
						oldValue.off(delegatedName, callback);
						}
					targetChangeSlot();
					let propModEventReg = /change:/;
					if (propModEventReg.test(delegatedName))
						{
						callback();
						}
				};

				let targetChangeSlot = () => {
					let target = this.get(targetName, null, null);
					if (target instanceof Object)
						{
						PF.H.useTrait(target, PF.Entity.EventsCoreTrait);

						target.on(delegatedName, callback);

						let delegatedEvent = undefined;
						for (let i = 0; i < this.entityDelegatedEvents.length; i++)
							{
							if (this.entityDelegatedEvents[i].name === name && this.entityDelegatedEvents[i].delegatedName === delegatedName && this.entityDelegatedEvents[i].callback === callback)
								{
								delegatedEvent = this.entityDelegatedEvents[i];
								}
							}
						if (delegatedEvent === undefined)
							{
							this.entityDelegatedEvents.push({
								type: 'entity',
								name: name,
								delegatedName: delegatedName,
								callback: callback,
								path: path.join('.'),
								targetName: targetName,
								target: target,
								// beforeChangeCallback: beforeChangeCallback,
								changeCallback: changeCallback,
							});
							}
						else
							{
							delegatedEvent.target = target;
							}
						}
				};

				// this.entityEvents.push({
				// 	name: 'beforeChange:' + targetName,
				// 	callback: beforeChangeCallback,
				// });
				// this.entityEvents.push({
				// 	name: 'change:' + targetName,
				// 	callback: changeCallback
				// });
				this.addEvent('change:' + targetName, changeCallback);

				this.defineProperty(targetName);
				targetChangeSlot();
				}
			}
		}

	pauseEvent(name)
		{
		let clearName = name.split('@')[0];
		let ns = name.split('@')[1];

		for (let i = 0; i < this.entityEvents.length; i++)
			{
			if (this.entityEvents[i].clearName === clearName && (this.entityEvents[i].ns === ns || ns === undefined))
				{
				this.entityEvents[i].pause = true;
				}
			}
		for (let i = 0; i < this.entityDelegatedEvents.length; i++)
			{
			let event = this.entityDelegatedEvents[i];
			if ((event.name === clearName))
				{
				if (event.type === 'entity')
					{
					event.target.pauseEvent(event.delegatedName+'@'+ns);
					}
				if (event.type === 'array')
					{
					for (let i = 0; i < this.length; i++)
						{
						this[i].pauseEvent(event.delegatedName+'@'+ns);
						}
					}
				}
			}

		}

	resumeEvent(name)
		{
		let clearName = name.split('@')[0];
		let ns = name.split('@')[1];

		for (let i = 0; i < this.entityEvents.length; i++)
			{
			if (this.entityEvents[i].clearName === clearName && (this.entityEvents[i].ns === ns || ns === undefined))
				{
				this.entityEvents[i].pause = false;
				}
			}

		for (let i = 0; i < this.entityDelegatedEvents.length; i++)
			{
			let event = this.entityDelegatedEvents[i];
			if ((event.name === clearName))
				{
				if (event.type === 'entity')
					{
					event.target.resumeEvent(event.delegatedName+'@'+ns);
					}
				if (event.type === 'array')
					{
					for (let i = 0; i < this.length; i++)
						{
						this[i].resumeEvent(event.delegatedName+'@'+ns);
						}
					}
				}
			}
		}

	trigger(name, ...args)
		{
		let clearName = name.split('@')[0];
		let ns = name.split('@')[1];

		let events = [];

		for (let i = 0; i < this.entityEvents.length; i++)
			{
			events.push(this.entityEvents[i]);
			}

		for (let i = 0; i < events.length; i++)
			{
			if (events[i].clearName === clearName && (events[i].ns === ns || ns === undefined) && events[i].pause !== true)
				{
				events[i].callback.apply(this, args);
				}
			}
		}

	off(name, callback)
		{
		let clearName = (name || "").split('@')[0];
		let ns = (name || "").split('@')[1];

		for (let i = 0; i < this.entityEvents.length; i++)
			{
			if ((this.entityEvents[i].clearName === clearName && (this.entityEvents[i].ns === ns || ns === undefined) || name === undefined) && (callback === this.entityEvents[i].callback || callback === undefined))
				{
				this.entityEvents.splice(i, 1);
				i--;
				}
			}
		for (let i = 0; i < this.entityDelegatedEvents.length; i++)
			{
			let event = this.entityDelegatedEvents[i];
			if ((event.name === name || name === undefined) && (callback === event.callback || callback === undefined))
				{
				if (event.type === 'entity')
					{
					this.off('change:' + event.targetName, event.changeCallback);
					event.target.off(event.delegatedName, event.callback);
					}
				if (event.type === 'array')
					{
					this.off('addOne', event.addCallback);
					this.off('removeOne', event.removeCallback);
					for (let i = 0; i < this.length; i++)
						{
						this[i].off(event.delegatedName, event.callback);
						}
					}
				this.entityDelegatedEvents.splice(i, 1);
				i--;
				}
			}
		}

	get(path, undefinedValue = undefined, nullValue = null, after = (v) => v)
		{
		return PF.H.get(this, path, undefinedValue, nullValue, after);
		}

	set(path, value)
		{
		return PF.H.set(this, path, value);
		}

	};